module.exports = __webpack_public_path__ + "img/login-logo.a97873d7.png";